(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory();
	else if(typeof define === 'function' && define.amd)
		define("Parallax", [], factory);
	else if(typeof exports === 'object')
		exports["Parallax"] = factory();
	else
		root["Parallax"] = factory();
})(this, function() {
return 